import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../../common/helpers/helpers";

const AssertionColumn = (props) => {
  const { assertionUrl, assertionType, assertionDirection } = props;
  return (
    <div>
      {assertionType && (
        <>
          {assertionUrl ? (
            <a target="_blank" href={getVarsoUrl(assertionUrl)}>
              {assertionType}
            </a>
          ) : (
            <>{assertionType}</>
          )}
        </>
      )}
      <br />
      {assertionDirection && (
        <small>
          {`Direction: ${assertionDirection}`}
          <br />
        </small>
      )}
    </div>
  );
};

AssertionColumn.propTypes = {
  assertionUrl: PropTypes.string,
  assertionType: PropTypes.string,
  assertionDirection: PropTypes.string,
};

AssertionColumn.defaultProps = {
  assertionUrl: "",
  assertionType: "",
  assertionDirection: "",
};

export default AssertionColumn;
